import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";
import { getTranslations } from "../Shared/translations";
import "./infobar.css";

import { CSSProperties } from "react";
import DotLoader from "react-spinners/BarLoader";
const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};


const Infobar = () => {
  console.log("🔁 Infobar rendered");
  const t = getTranslations();
/*
  const ShowLoading = () => {
    return (
      <div className="sweet-loading">
        <DotLoader
          color={"#F3BA0D"}
          loading={true}
          cssOverride={override}
          height={10}
          width={300}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>
    );
  };
  */
  //{this.props.calculating === true ? this.ShowLoading() : ""}

    return (
      <div className="bar">
        <Stack direction="horizontal" gap={2}>
          <Badge bg="secondary">
            {t.typeUitvoering}: {sessionStorage.getItem("uitvoeringText")}
          </Badge>
          <Badge bg="secondary">
            {t.klant}: {sessionStorage.getItem("eindklant")}
          </Badge>
          <Badge bg="secondary">
            {t.project}: {sessionStorage.getItem("bestandsnaam")}
          </Badge>

        </Stack>
      </div>
    );

}
export default Infobar;
